export default __webpack_public_path__ + "static/media/muscle-spasm.dae576d3.png";